import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/kara_logo_white.png'


const _withScopeId = n => (_pushScopeId("data-v-0b33ee45"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "header-img" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "header-img-bg" }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"width":"200px","height":"auto","position":"absolute","bottom":"1rem","right":"1rem"},
    alt: "KaRa Logo"
  })
], -1))
const _hoisted_2 = { style: {"min-height":"0 !important"} }
const _hoisted_3 = { id: "content-waterfall" }
const _hoisted_4 = { style: {"text-align":"center","line-height":"2rem","padding":"2rem"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"font-size":"500%"} }, "Welcome", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"font-size":"300%"} }, "to the German space catalog", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { id: "header-separator" }, null, -1))
const _hoisted_8 = { style: {"text-align":"justify","font-size":"115%"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "big-search-button",
  type: "submit"
}, "Search", -1))
const _hoisted_10 = {
  id: "advanced-links",
  style: {"margin-top":"1rem"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("main", { style: {"min-height":"0 !important"} }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "About KaRA"),
    /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify"} }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla in tortor vel dui tincidunt feugiat. Aenean elementum erat et velit sagittis, et vulputate erat aliquam. Etiam eu ante hendrerit, auctor lorem quis, ultrices sapien. Vestibulum lectus tortor, elementum sed euismod a, volutpat ut justo. Integer purus turpis, cursus non pellentesque quis, fermentum ac massa. Etiam ut cursus elit. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Aliquam erat volutpat. Donec et metus feugiat, dapibus leo sed, blandit lectus. Praesent interdum facilisis pulvinar. ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GMapMap = _resolveComponent("GMapMap")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("p", _hoisted_8, [
            _createTextVNode(" The world is moving closer together. Not only literally, in the sense of a globally growing population, but also through digitization as a driver of economic and social networking. Space plays an essential role in this process by providing indispensable infrastructures for research, business, communications, navigation, finance as well as earth and environmental observation. Additionally, a paradigm shift in space travel has taken place in recent years. International corporations, ... "),
            _createVNode(_component_router_link, { to: "/about" }, {
              default: _withCtx(() => [
                _createTextVNode("continue reading")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("form", {
          style: {"position":"relative","margin-bottom":"1rem"},
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doSearch && _ctx.doSearch(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            id: "big-search-field",
            type: "search",
            placeholder: "Search...",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event))
          }, null, 512), [
            [_vModelText, _ctx.query]
          ]),
          _hoisted_9
        ], 32),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, { to: "/directory" }, {
            default: _withCtx(() => [
              _createTextVNode("Browse All Companies")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/categories" }, {
            default: _withCtx(() => [
              _createTextVNode("Browse Categories")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/search" }, {
            default: _withCtx(() => [
              _createTextVNode("Advanced Search")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_GMapMap, {
      center: {lat: 51.16077, lng: 10.448851},
      zoom: 7,
      "map-type-id": "terrain",
      style: {"width":"calc(100vw - 20px)","height":"calc(min((515 / 381) * (100vw - 20px), 80vh))","margin-left":"auto","margin-right":"auto"}
    }, null, 8, ["center"]),
    _hoisted_11
  ], 64))
}